import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "default-form" }
const _hoisted_2 = { class: "input-row" }
const _hoisted_3 = { class: "input-wr" }
const _hoisted_4 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_5 = { class: "input-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "dashboard-header" }, [
      _createElementVNode("h2", { class: "title-main" }, "Update Stage")
    ], -1)),
    _createElementVNode("form", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("label", { class: "label" }, "Stage Number", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.title.$error }]),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.title) = $event)),
            type: "text",
            placeholder: "Stage Number"
          }, null, 2), [
            [
              _vModelText,
              $setup.form.title,
              void 0,
              { trim: true }
            ]
          ]),
          ($setup.v$.title.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.v$.title.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "button default outlined cancel-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.router.go(-1))),
          type: "button"
        }, "Cancel"),
        _createElementVNode("button", {
          class: "button default primary create-btn",
          onClick: $setup.updateStage,
          type: "button"
        }, "Update")
      ])
    ])
  ], 64))
}